export interface Task {
  id: string;
  type: TaskType;
  timestamp: number;
  createdAt: number;
  updatedAt: number;
  path?: string;
  /** Thread chat (UUID) — aligne le poll /docprocessbar avec le document ES. */
  threadId?: string;
  file: {
    filename: string;
    nbPages: number;
    nbProcessed: number;
    nbProcessedSummary: number;
    status: string;
  };
  status: TaskStatus;
  page?: string;
  mode?: string;
  /** True uniquement pour EXHAUSTIVE_SEARCH (job serveur) — POST /chat/exhaustive-search/resume */
  requiresServerResume?: boolean;
  /** Exhaustif WIP tableau : formule RAG compacte (ex. docs×colonnes÷lot, ex. ``40*8/3``). */
  legalWipJobFormula?: string;
  /** Détail textuel de progression renvoyé par le backend. */
  legalProgressDetail?: string;
  /** Phase fine du job exhaustif (préparation / docs / synthèse). */
  legalWipPhase?: string;
}

export enum TaskType {
  UPLOAD = "upload",
  SUMMARY = "summary",
  LEGAL_SEARCH = "legal_search",
}

export enum TaskStatus {
  PROCESSING = "processing",
  SUMMARIZING = "summarizing",
  COMPLETED = "completed",
  CANCELLED = "cancelled",
  ERROR = "error",
}
